// Email alert types a person can choose (in My Account). Each maps to Action Centre areas.
export const ALERT_CATEGORIES = [
  ["dates", "Overdue Time & Action Plan dates", "A PO's ETD has passed and it isn't shipped yet."],
  ["samples", "Samples waiting for approval", "Samples, fit samples and PPS to check or approve, and rejected 2nd rounds."],
  ["qc", "QC results", "QC reports to review, reports to finish, failed QC and 2nd QC needed."],
  ["compliance", "Expiring certificates", "Compliance certificates that have expired or expire within 90 days."],
  ["shipments", "Shipments due", "Ready to Ship items to put on a shipment, and landed shipments to mark Received."],
  ["tasks", "My tasks due", "Tasks assigned to you that are due today or overdue."],
] as const;
export type AlertCategory = (typeof ALERT_CATEGORIES)[number][0];
export const ALERT_MODES = [["off", "Off"], ["daily", "One daily summary"], ["instant", "As they happen"]] as const;
export type AlertMode = (typeof ALERT_MODES)[number][0];

const AREA_CATEGORY: Record<string, AlertCategory> = { Dates: "dates", Sampling: "samples", QC: "qc", Compliance: "compliance", Shipping: "shipments", Receiving: "shipments", Tasks: "tasks" };
/** Which alert type an Action Centre item belongs to (null: not emailed, e.g. production steps). */
export const categoryOf = (area: string): AlertCategory | null => AREA_CATEGORY[area] ?? null;
